export default __webpack_public_path__ + "static/media/logo.d2537d89.png";